var _jsxFileName = "/codebuild/output/src3324671287/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/AppLogo/index.tsx";
import React from 'react';
import { Stack } from '@adc/parallax-component-library';
import { ThemedImage } from '../ThemedImage';
function AppLogo({
  isMobileBrowser = false
}) {
  return /*#__PURE__*/React.createElement(Stack, {
    padding: isMobileBrowser ? '$4' : 40,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ThemedImage, {
    resourceKey: "Global.microcopy.common.libreLogoLight",
    alt: "",
    id: "Global.microcopy.common.libreLogo",
    style: {
      height: isMobileBrowser ? '32px' : '52px',
      objectFit: 'contain'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 7
    }
  }));
}
export { AppLogo };